__turbopack_context__.v({
  "footer": "loJ5xW_footer",
});
